import $ from "jquery";
import { useState } from "react";
import { useSelector } from "react-redux";
import useApi from "../../../CustomHooks/useApi";
import useRDService from "../../../CustomHooks/useRDService";
import DeviceStatus from "./DeviceStatus";
import AepsForm from "./AepsForm";

const AepsIntegration = () => {

  const { device, captureFingerprint, loading } =
    useRDService();

  const merchantdetails = useSelector(
    (state) => state.auth?.employeeDetails
  );

  const { lat, lng } = useSelector(
    (state) => state.location
  );

  const [processing, setProcessing] = useState(false);

  const userId = merchantdetails?.userId;

  const latitude = lat;
  const longitude = lng;

  const {
    callApi: balanceEnquiryApi
  } = useApi(
    "/aeps/balance/inquiry",
    "POST"
  );

  const {
    callApi: cashWithdrawalApi
  } = useApi(
    "/aeps/transfer/money",
    "POST"
  );

  const {
    callApi: otpApi
  } = useApi(
    "/aeps/transaction/otp",
    "POST"
  );

  const {
    callApi: miniStatementApi
  } = useApi(
    "/aeps/mini/statement",
    "POST"
  );

  const [popup, setPopup] = useState({
    show: false,
    title: "",
    message: ""
  });

  const [previousData, setPreviousData] = useState(null);
  const [clearFormTrigger, setClearFormTrigger] = useState(0);

  const [otpPopup, setOtpPopup] = useState({
    show: false,
    otp: "",
    referenceKey: "",
    pendingFormData: null,
    submitting: false,
  });

  const closePopup = () => {

    // Clear form on ANY popup OK (success or error)
    if (
      popup.show
    ) {
      setClearFormTrigger(prev => prev + 1);
    }

    setPopup({
      show: false,
      title: "",
      message: ""
    });
  };


  const handleOtpSubmit = async () => {
    const formData = otpPopup.pendingFormData;
    try {
      setOtpPopup(p => ({ ...p, submitting: true }));
      setProcessing(true);

      const pidXml = await captureFingerprint("", otpPopup.otp);

      if (!pidXml || !pidXml.includes('errCode="0"')) {
        setOtpPopup({ show: false, otp: "", referenceKey: "", pendingFormData: null, submitting: false });
        setProcessing(false);
        setPopup({ show: true, title: "Failed", message: "Fingerprint Capture Failed" });
        return;
      }

      const pidData = parsePidXml(pidXml);

      const requestBody = {
        bankiin: formData?.bank?.iin,
        latitude: latitude?.toString(),
        longitude: longitude?.toString(),
        biometricData: pidData,
        aadhaar: formData.aadhaar,
        mobile: formData.mobile,
        mid: userId,
        selectedDevice: device || "MANTRA",
        amount: formData.amount,
        referenceKey: otpPopup.referenceKey,
      };

      const response = await cashWithdrawalApi(requestBody);

      setOtpPopup({ show: false, otp: "", referenceKey: "", pendingFormData: null, submitting: false });
      setProcessing(false);

      if (response?.statuscode === "TXN") {
        setPopup({
          show: true,
          title: "Cash Withdrawal Success",
          message:
            `Bank Name : ${response?.data?.bankName}

Withdraw Amount : ₹${response?.amount}

Avl Balance: ₹${response?.data?.bankAccountBalance}

Bank RRN : ${response?.bank_rrn}
Aadhar No : ${response?.aadhaarNo}`
        });
      } else {
        setPopup({
          show: true,
          title: "Failed",
          message:
            response?.reason ||
            response?.status ||
            "Cash Withdrawal Failed"
        });
      }
    } catch (err) {
      console.log("OTP Submit Error", err);
      setOtpPopup(p => ({ ...p, submitting: false }));
      setProcessing(false);
      setPopup({ show: true, title: "Error", message: err?.message || "Transaction Failed" });
    }
  };

  const parsePidXml = (xml) => {

    const $xml = $(xml);

    const get = (selector, attr) =>
      $xml.find(selector).attr(attr) || "0";

    const infoValue = (name) =>
      $xml.find(`Info[name='${name}']`).attr("value") ||
      $xml.find(`Param[name='${name}']`).attr("value") ||
      "0";

    return {
      dc: get("DeviceInfo", "dc"),
      ci: get("Skey", "ci"),
      hmac: $xml.find("Hmac").text() || "0",
      dpId: get("DeviceInfo", "dpId"),
      mc: get("DeviceInfo", "mc"),
      pidDataType: get("Data", "type"),
      sessionKey: $xml.find("Skey").text() || "0",
      mi: get("DeviceInfo", "mi"),
      rdsId: get("DeviceInfo", "rdsId"),
      errCode: get("Resp", "errCode"),
      errInfo: get("Resp", "errInfo"),
      fCount: get("Resp", "fCount"),
      fType: get("Resp", "fType"),
      iCount: get("Resp", "iCount"), // blank hua toh 0 jayega
      iType: get("Resp", "iType"),
      pCount: get("Resp", "pCount"),
      pType: "0",
      srno: infoValue("srno"),
      sysid: infoValue("sysid"),
      ts: infoValue("ts"),
      pidData: $xml.find("Data").text() || "0",
      qScore: get("Resp", "qScore"),
      nmPoints: get("Resp", "nmPoints"),
      rdsVer: get("DeviceInfo", "rdsVer"),
    };
  };


  const handleCapture = async (formData) => {

    try {

      setProcessing(true);
      setPreviousData({
        ...formData
      });

      // ── OTP gate: CW > ₹5,000 ────────────────────────────
      let referenceKey = null;
      if (formData.txnType === "CW" && Number(formData.amount) > 5000) {
        const otpRes = await otpApi({
          mid: userId,
          bankiin: formData?.bank?.iin,
          latitude: latitude?.toString(),
          longitude: longitude?.toString(),
          mobile: formData.mobile,
          amount: String(formData.amount),
          aadhaar: formData.aadhaar,
        });

        if (otpRes?.statuscode === "OTP") {
          setOtpPopup({
            show: true,
            otp: "",
            referenceKey: otpRes?.data?.referenceKey || "",
            pendingFormData: formData,
            submitting: false,
          });
          setProcessing(false);
          return;
        }
        // statuscode === "TXN" → OTP not required, continue normally
      }
      // ─────────────────────────────────────────────────────

      const pidXml = await captureFingerprint("");

      console.log("Raw PID XML:", pidXml);

      if (
        !pidXml ||
        !pidXml.includes('errCode="0"')
      ) {
        setProcessing(false);
        setPopup({
          show: true,
          title: "Failed",
          message: "Fingerprint Capture Failed"
        });
        return;
      }

      const pidData = parsePidXml(pidXml);

      const baseRequest = {
        bankiin: formData?.bank?.iin,
        latitude: latitude?.toString(),
        longitude: longitude?.toString(),
        biometricData: pidData,
        aadhaar: formData.aadhaar,
        mobile: formData.mobile,
        mid: userId,
        selectedDevice: device || "MANTRA"
      };


      if (formData.txnType === "BE") {

        const response =
          await balanceEnquiryApi(baseRequest);

        console.log(response);

        if (
          response?.statuscode === "TXN"
        ) {

          setProcessing(false);

          setPopup({
            show: true,
            title: "Balance Enquiry Success",
            message:
              `Bank Name : ${response?.data?.bankName}

Balance : ₹${response?.data?.bankAccountBalance}`
          });

        }
        else {

          setProcessing(false);

          setPopup({
            show: true,
            title: "Transaction Failed",
            message:
              response?.reason ||
              response?.status ||
              "Transaction Failed"
          });

        }
      }


      if (formData.txnType === "CW") {

        const requestBody = {
          ...baseRequest,
          amount: formData.amount,
          ...(referenceKey ? { referenceKey } : {}),
        };

        const response = await cashWithdrawalApi(requestBody);

        console.log(response);

        if (
          response?.statuscode === "TXN"
        ) {

          setProcessing(false);

          setPopup({
            show: true,
            title: "Cash Withdrawal Success",
            message: `Bank Name : ${response?.data?.bankName}

Withdraw Amount : ₹${response?.amount}

Avl Balance: ₹${response?.data?.bankAccountBalance}

Bank RRN : ${response?.bank_rrn}
Aadhar No : ${response?.aadhaarNo}`
          });

        } else {

          setProcessing(false);

          setPopup({
            show: true,
            title: "Failed",
            message:
              response?.reason ||
              response?.status ||
              "Cash Withdrawal Failed"
          });
        }
      }


      if (formData.txnType === "MS") {

        const response = await miniStatementApi(baseRequest);

        console.log(response);

        if (
          response?.statuscode === "TXN"
        ) {

          const statementText =
            response?.data?.miniStatement?.length > 0
              ? response.data.miniStatement
                .slice(0, 5)
                .map(
                  item =>
                    `${item.date} | ${item.txnType} | ₹${item.amount}`
                )
                .join("\n")
              : "No Mini Statement Available";

          setProcessing(false);

          setPopup({
            show: true,
            title: "Mini Statement Success",
            message: `Bank Name : ${response?.data?.bankName}

Available Balance : ₹${response?.data?.bankAccountBalance}

Recent Transactions:
${statementText}`
          });

        } else {

          setProcessing(false);

          setPopup({
            show: true,
            title: "Failed",
            message:
              response?.reason ||
              response?.status ||
              "Mini Statement Failed"
          });
        }
      }

    }
    catch (err) {

      console.log("AEPS Error", err);

      setProcessing(false);

      setPopup({
        show: true,
        title: "Error",
        message:
          err?.message ||
          "Transaction Failed"
      });

    }
  };


  return (
    <div>

      <DeviceStatus
        device={device}
      />

      <AepsForm
        onSubmit={handleCapture}
        processing={processing}
        loading={loading}
        previousData={previousData}
        clearFormTrigger={clearFormTrigger}
      />


      {/* OTP Popup — shown when CW > ₹5,000 and UIDAI sends OTP */}
      {otpPopup.show && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-3xl shadow-2xl p-8 w-[420px] text-center">

            <h2 className="text-2xl font-semibold">Enter OTP</h2>

            <p className="mt-3 text-[15px] text-gray-500 leading-6">
              An OTP has been sent to the customer's Aadhaar-registered mobile number.
              Enter the OTP below, then place the finger on the scanner.
            </p>

            <input
              type="text"
              inputMode="numeric"
              maxLength={6}
              value={otpPopup.otp}
              onChange={(e) =>
                setOtpPopup(p => ({ ...p, otp: e.target.value.replace(/\D/g, "") }))
              }
              placeholder="• • • • • •"
              className="mt-6 w-full border-2 border-gray-300 rounded-xl px-4 py-4 text-3xl tracking-[0.5em] text-center font-mono focus:outline-none focus:border-blue-500"
            />

            <div className="mt-6 flex gap-3">
              <button
                onClick={() =>
                  setOtpPopup({ show: false, otp: "", referenceKey: "", pendingFormData: null, submitting: false })
                }
                disabled={otpPopup.submitting}
                className="flex-1 border-2 border-gray-300 text-gray-600 py-3 rounded-xl font-semibold hover:bg-gray-50 disabled:opacity-50"
              >
                Cancel
              </button>
              <button
                onClick={handleOtpSubmit}
                disabled={otpPopup.otp.length < 4 || otpPopup.submitting}
                className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-semibold disabled:opacity-50"
              >
                {otpPopup.submitting ? "Processing…" : "Submit & Scan"}
              </button>
            </div>

          </div>
        </div>
      )}

      {popup.show && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-3xl shadow-2xl p-8 w-[420px] text-center">

            <h2 className="text-2xl font-semibold">
              {popup.title}
            </h2>

            <p className="mt-5 whitespace-pre-line text-[18px] font-bold text-gray-700 leading-8">
              {popup.message}
            </p>

            <button
              onClick={closePopup}
              className="mt-6 bg-blue-600 hover:bg-blue-700 text-white px-10 py-3 rounded-xl"
            >
              OK
            </button>

          </div>
        </div>
      )}

    </div>
  );
};

export default AepsIntegration;


